<span data-testid="tag-text" [attr.data-state]="status()" [ngClass]="['ap-tag', 'ap-tag--' + status()]">
    <ng-content></ng-content>
</span>
